export const CATEGORIES = ["Live Stock","Farm Tools & Equipment","Fertilizers"]
export const GRAND_CATEGORIES = ["Livestock Inputs","Crops Seeds & Inputs","Omia foods","Irrigation & Green Houses"]
export const SERVICE_CATEGORIES = ["Crop Support","Livestock Support","Other Services"]
export const SUB_CATEGORIES = {
    "Crops Seeds & Inputs": ["Seeds","Fertilizers","Herbicides","Fungicides","Insecticides","Other Agrochemicals","Farm Tools and Equipment"],
    "Livestock Inputs": ["Vaccines","Feed","Drugs","Livestock"],
    "Omia foods": ["Vegetables and Fruits","Grains and Dry Foods","Chicken","Eggs",".Other Meat Products"],
    "Irrigation & Green Houses": ["Equipments and Kits","Accesories","Green Houses","Other Structures"],
}
export const MEASUREMENT_UNITS = ["Kg","g","Ltr","mL","No.","m"]